import i18next from 'i18next';
import english from './en.json';
import french from './fr.json';

import { initReactI18next } from 'react-i18next';
import { constants } from '../constants';
import { retrieveData, storeData } from '../helper/storageHelper';

const languageDetector = {
  init: Function.prototype,
  type: 'languageDetector',
  async: true,
  detect: async (callback) => {
    callback(retrieveData(constants.languageKey) || constants.defaultLanguage);
  },
  cacheUserLanguage: (language) => {
    if (language) {
      storeData(constants.languageKey, language);
    }
  },
};
i18next
  .use(languageDetector)
  .use(initReactI18next)
  .init({
    compatibilityJSON: 'v3',
    resources: {
      ENGLISH: english,
      FRENCH: french,
    },
    fallbackLng: 'FRENCH',

    interpolation: {
      escapeValue: false,
    },
  });

export default i18next;
